import { type RPPDomain } from 'utils/core/RPPCore.types'
import { NavItem } from 'legacy/components/Nav/nav.types'
import { retailerFundedMarketingRouter } from 'domains/retailer-funded-marketing/routing/retailerFundedMarketingRouter'
import { retailerFundedMarketingAdminRouter } from 'domains/retailer-funded-marketing/routing/retailerFundedMarketingAdminRouter'
import { type DomainMessages } from 'domains/retailer-funded-marketing/utils/domain/intl'
import { routes } from 'domains/retailer-funded-marketing/routing/routes'
import EN_US from 'domains/retailer-funded-marketing/translations/en-US'
import { type DomainAccessControlConfig } from 'domains/retailer-funded-marketing/utils/domain/accessControl'
import { retailerFundedMarketingPhaseFourHomeAccessControl } from 'domains/retailer-funded-marketing/access-control/retailerFundedMarketingPhaseFourHomeAccess.configuration'
import { retailerFundedMarketingHomeAccessControl } from 'domains/retailer-funded-marketing/access-control/retailerFundedMarketingHomeAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'retailer-funded-marketing',
  routes,
  translations: { EN_US },
  routers: {
    scoped: [retailerFundedMarketingRouter],
    admin: [retailerFundedMarketingAdminRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.RetailerFundedMarketing,
      subNavItems: [
        {
          type: 'item',
          labelId: 'retailerFundedMarketingDomain.campaigns.nav',
          route: 'retailer-funded-marketing-list',
          accessControl: retailerFundedMarketingHomeAccessControl,
        },
        {
          type: 'item',
          labelId: 'retailerFundedMarketingDomain.campaigns.phaseFour.nav',
          route: 'retailer-funded-marketing-site-scoped-list',
          accessControl: retailerFundedMarketingPhaseFourHomeAccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
